import { cn } from "@/lib/utils";
import { type User } from "@/types";

import { type Conversation } from "../types";
import MessengerConversationTabs from "./MessengerConversationTabs";
import MessengerHeader from "./MessengerHeader";
import GroupCreateFlow from "./creating-groups/GroupCreateFlow";

interface MessengerListPanelProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  showToggle?: boolean;
  showSearch?: boolean;
  className?: string;
  tabsClassName?: string;
  searchClassName?: string;
  searchHeaderClassName?: string;
  activeConversationId?: number;
  onConversationClick: (conversation: Conversation<true, true, true>) => void;
  onUserClick: (user: User<true>) => void;
}

export default function MessengerListPanel({
  open,
  setOpen,
  showToggle = false,
  showSearch = false,
  className,
  tabsClassName,
  searchClassName,
  searchHeaderClassName,
  activeConversationId,
  onConversationClick,
  onUserClick,
}: MessengerListPanelProps) {
  return (
    <div className="relative flex h-full flex-col overflow-hidden">
      <MessengerHeader
        open={open}
        setOpen={setOpen}
        onUserClick={onUserClick}
        showToggle={showToggle}
        showSearch={showSearch}
        className={className}
        searchClassName={searchClassName}
        searchHeaderClassName={searchHeaderClassName}
      />
      <div className={cn("flex-1 overflow-hidden", tabsClassName)}>
        <MessengerConversationTabs
          open={open}
          onConversationClick={onConversationClick}
          onUserClick={onUserClick}
          activeConversationId={activeConversationId}
        />
      </div>
      <GroupCreateFlow open={open} />
    </div>
  );
}
